import { useState } from "react";
import firebase from "../../config/firebase";
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { addCatalog } from "store/actions/catalogAction";
import PickDateRange from "components/shared/PickDateRange";

function AddCatalogModal({ addModal, addToggle }) {
  const dispatch = useDispatch();
  const { addLoading, catalogs } = useSelector((state) => state.catalog);
  const { user } = useSelector((state) => state.auth);

  const [error, setError] = useState({});
  const [formData, setFormData] = useState({
    category: "",
    startTime: "",
    endTime: "",
    availability: "",
  });

  const [datestate, setDateState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));

    if (name === "category") {
      const categoryExists = catalogs.some(
        (c) => c.category === value && c.restaurantID === user.id
      );
      setError({
        ...error,
        category: categoryExists ? "This category already exists!" : "",
      });
    }
  };

  const handleAddToggle = () => {
    setFormData({
      category: "",
      startTime: "",
      endTime: "",
      availability: "",
    });
    setDateState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
    setError({});
    addToggle();
  };

  const handleCatalogSubmit = (e) => {
    e.preventDefault();

    const catalogData = {
      ...formData,
      ...(formData.availability === "available specific day" && {
        availabilityDate: {
          startDate: datestate[0]?.startDate,
          endDate: datestate[0]?.endDate,
        },
      }),
      restaurantID: user?.restaurantID,
      createdAt: firebase.firestore.Timestamp.now(),
    };

    dispatch(
      addCatalog(catalogData, () => {
        handleAddToggle();
      })
    );
  };

  const isDataValid =
    formData.category &&
    formData.startTime &&
    formData.endTime &&
    formData.availability &&
    (formData.availability !== "available specific day" ||
      (datestate[0]?.startDate && datestate[0]?.endDate));

  return (
    <div>
      <Modal isOpen={addModal}>
        <ModalHeader toggle={handleAddToggle}>Add Catalog Details</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleCatalogSubmit}>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="location">Categories</Label>
                  <Input
                    type="select"
                    id="exampleCustomSelect"
                    name="category"
                    required
                    value={formData.category}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select Categories
                    </option>
                    {["breakfast", "lunch", "dinner"].map((cat) => {
                      const alreadyPresent = catalogs.some(
                        (c) =>
                          c.category === cat &&
                          c.restaurantID === user?.restaurantID
                      );

                      return (
                        <option key={cat} value={cat} disabled={alreadyPresent}>
                          {cat.charAt(0).toUpperCase() + cat.slice(1)}
                          {alreadyPresent ? " (Already Added)" : ""}
                        </option>
                      );
                    })}
                  </Input>

                  {error?.category && (
                    <p className="text-sm text-danger">{error?.category}</p>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="start-time">Availability</Label>
              <Input
                type="select"
                name="availability"
                required
                placeholder="Availability"
                value={formData.availability}
                onChange={handleInputChange}
              >
                <option value="">Please select</option>
                <option value="available every day">Available Every Day</option>
                <option value="available specific day">
                  Available Specific Day
                </option>
              </Input>
            </FormGroup>

            {formData.availability === "available specific day" && (
              <Row>
                <Col className="mb-3 catalog__picker">
                  <PickDateRange
                    setDateState={setDateState}
                    datestate={datestate}
                    disablePast={true}
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                <FormGroup>
                  <Label for="start-time">Start Time</Label>
                  <Input
                    type="time"
                    name="startTime"
                    id="date-inp"
                    required
                    placeholder="Start time"
                    value={formData.startTime}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="start-time">End Time</Label>
                  <Input
                    type="time"
                    name="endTime"
                    id="date-inp"
                    required
                    placeholder="End time"
                    value={formData.endTime}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button color="primary" disabled={addLoading || !isDataValid}>
                {addLoading ? <Spinner size="sm" /> : "Add"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default AddCatalogModal;
